import React from 'react';
import TryhardH2 from '../../TryhardMarkups';
import TryhardCategories from './TryhardCategories';
import TryhardPageFrame from '../TryhardPageFrame';

const TryhardHome: React.FC = () => {
    return (
        <TryhardPageFrame key='home'>
            {/* Categories */}
            <div className='flex flex-col items-center gap-y-4 pt-4 py-2'>
                <TryhardH2><span className='underline'>What We Do</span></TryhardH2>
                <TryhardCategories />
            </div>

            {/* Street cred */}
            <div className='flex flex-col items-center gap-y-4 pt-6 py-2'>
                <TryhardH2>Professional vendor for...</TryhardH2>
                <img className='w-3/5 md:w-[730px]' src='thg/graphics/comiccon_logo.png' />
            </div>
        </TryhardPageFrame>
    )
}

export default TryhardHome;